import { render, staticRenderFns } from "./PartnerLinkPanel.vue?vue&type=template&id=313cb04d&scoped=true"
import script from "./PartnerLinkPanel.vue?vue&type=script&lang=js"
export * from "./PartnerLinkPanel.vue?vue&type=script&lang=js"
import style0 from "./PartnerLinkPanel.vue?vue&type=style&index=0&id=313cb04d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313cb04d",
  null
  
)

export default component.exports